import React from "react";
import PropTypes from "prop-types";
import { useTable } from "react-table";

export default function FileTransfersTable({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data
  });

  if (rows?.length === 0) {
    return <span>You currently do not have any files</span>;
  }

  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups?.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows?.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => <td {...cell.getCellProps()}>{cell.render("Cell")}</td>)}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

FileTransfersTable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array
};
